import { render, staticRenderFns } from "./EventListing.vue?vue&type=template&id=228de4c3"
import script from "./EventListing.vue?vue&type=script&lang=js"
export * from "./EventListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports